export default __webpack_public_path__ + "static/media/tk_new2.b7b79c35.png";